import { useUser } from '@clerk/clerk-react'

export type UserRole = 'admin' | 'user'

/**
 * Hook to check if the current user has a specific role
 */
export function useRole() {
  const { user } = useUser()

  const checkRole = (role: UserRole): boolean => {
    if (!user) return false

    // Check publicMetadata for role
    const userRole = user.publicMetadata?.role as UserRole | undefined
    return userRole === role
  }

  const isAdmin = (): boolean => {
    return checkRole('admin')
  }

  return {
    checkRole,
    isAdmin,
    role: user?.publicMetadata?.role as UserRole | undefined
  }
}
